export default __webpack_public_path__ + "static/media/Terra.990ac782.png";